/****************************************************
 * Module Name:  lossMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import LossProxy from "../../utility/proxy/manager/manufacturingProxy/lossProxy";
import AddLossModal from "./addLossModal";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class LossMaster extends Component {
    constructor(props) {
        super(props);

        this.state = {
            losss: [],
            showAddLossModal: false,

            editOperation: false,
            sourceData: {},
            snackbarVariant: "",
            snackbarMessage: "",
            showSnackbar: "",
            loadingButton: false,
            accesDenied: false,
            showLossLoadSpinner: true,
            local_Permission: Constants.USER_PERMISSION.filter(
                (iPermission) =>
                    iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_MASTER_LOSS
            ),
        };

        this.checkPermission()
    }

    componentDidMount() {
        PageTitle("MANUFACTURING_MASTER_LOSS");
    }

    checkPermission = () => {
        let allowed = Utility.isReadAllowed(this.state.local_Permission)
        if (!allowed) {
            this.setState({
                accesDenied: true
            })
        } else {
            this.fetchLossData(false);
        }
    }

    fetchLossData = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showLossLoadSpinner: true });
        LossProxy.GetAllLoss((responseData) => {
            if (responseData) {
                this.setState({ losss: responseData, showLossLoadSpinner: false })
            } else {
                this.setState({ showLossLoadSpinner: false })
                this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        }
        );
    };

    setSnackbarState = (show, message, variant) => {
        this.setState({
            showSnackbar: show,
            snackbarMessage: message,
            snackbarVariant: variant,
        })
    }

    columns = [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            align: "center",
            minWidth: 50,
        },
        {
            field: "category",
            headerName: "LOSS CATEGORY",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            flex: 1,
            minWidth: 150,
            type: "date",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => {
                if (params.value) {
                    return Utility.ConvertUtcToLocalTime(params.value);
                } else {
                    return "";
                }
            }
        },
        {
            field: "description",
            headerAlign: "center",
            align: "center",
            headerName: "DESCRIP",
            flex: 1,
            minWidth: 150,
            renderCell: renderCellExpand,
        },
        {
            field: "edit",
            headerName: "EDIT",
            headerAlign: "center",
            align: "center",
            flex: 0.5,
            minWidth: 50,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Box
                        style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => {
                            this.setState({
                                showAddLossModal: true,
                                editOperation: true,
                                sourceData: params.row,
                                loadingButton: false,
                            });
                        }}
                    >
                        {" "}
                        <BorderColorIcon color="primary" />
                    </Box>
                );
            },
        },
    ];

    handleValidation = (lossData) => {
        //TODO do validation if needed here
        return true;
    };

    addLoss = (lossData) => {
        this.setState({ loadingButton: true });
        if (this.state.editOperation) {
            //Updating Loss, and once loss is updated on call refresh the list of current losss
            LossProxy.UpdateLoss(lossData, (response) => {
                if (response) {
                    this.fetchLossData(true);
                    this.setState({ loadingButton: false, showAddLossModal: false });
                    this.setSnackbarState(true, "Loss updated successfully", "success");
                } else {
                    this.setState({ loadingButton: false });
                    this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                }
            });
        } else {
            //Creating new Loss, and once loss is created on call refresh the list of current losss
            LossProxy.AddLoss(lossData, (response) => {
                if (response) {
                    this.fetchLossData(true);
                    this.setState({ loadingButton: false, showAddLossModal: false });
                    this.setSnackbarState(true, "Loss Added successfully", "success");
                } else {
                    this.setState({ loadingButton: false });
                    this.setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                }
            });
        }
    };

    render() {
        let allowed = Utility.isReadAllowed(this.state.local_Permission)
        if (!allowed) {
            return <NoPermission />
        }
        const rows = this.state.losss;
        const columns = Utility.isUpdateAllowed(this.state.local_Permission)
            ? this.columns
            : this.columns.filter((col) => col.field !== "edit");
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showSnackbar}
                    message={this.state.snackbarMessage}
                    variant={this.state.snackbarVariant}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={() => this.setState({ showSnackbar: false })}
                    title={this.state.snackbarVariant}
                />
                <br />
                {this.state.showAddLossModal ? (
                    <AddLossModal
                        Show={true}
                        handleClose={() => this.setState({ showAddLossModal: false })}
                        handleSave={this.addLoss}
                        handleValidation={this.handleValidation}
                        editOperation={this.state.editOperation}
                        sourceData={this.state.sourceData}
                        loading={this.state.loadingButton}
                    />
                ) : (
                    <Box />
                )}
                <Box px={1}>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            height: "83vh",
                        }}
                    >
                        <DataGridPro
                            disableRowSelectionOnClick={true}
                            getRowHeight={() => "auto"}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },
                                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            }}
                            density="compact"
                            slots={{ toolbar: GridToolbar }}
                            rows={rows}
                            columns={columns}
                            getRowId={(row) => row.id}
                            loading={this.state.showLossLoadSpinner}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        // Hide columns status and traderName, the other columns will remain visible
                                        id: false,
                                    },
                                },
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                        <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                            {this.state.showLossLoadSpinner ? (
                                <CircularProgress size="1rem" />
                            ) : (
                                <Tooltip title="Reload List">
                                    <RefreshOutlinedIcon
                                        color="primary"
                                        fontSize="medium"
                                        onClick={() => this.fetchLossData(true)}
                                        sx={{ cursor: "pointer" }}
                                    />
                                </Tooltip>
                            )}
                            {Utility.isAddAllowed(this.state.local_Permission) ? (
                                <Tooltip title="Add Loss Category">
                                    <Button
                                        color="info"
                                        variant="outlined"
                                        size="small"
                                        sx={{ ml: "5px" }}
                                        onClick={() =>
                                            this.setState({
                                                showAddLossModal: true,
                                                editOperation: false,
                                                sourceData: {},
                                            })
                                        }
                                        startIcon={<AddBoxOutlinedIcon size="large" />}
                                    >
                                        Loss Category
                                    </Button>
                                </Tooltip>
                            ) : null}
                        </Box>
                    </Box>
                </Box>
            </Box >
        );
    }
}

export default LossMaster;
